import { Dispatch, SetStateAction } from 'react';
import { Code } from 'react-content-loader';
import { isMobile } from 'react-device-detect';
import CharacterAdditionalInfo from 'components/ai/tools/CharacterAdditionalInfo';
import { useMappedState } from 'redux-react-hook';
import styled from 'styled-components';

import AssetDialogCard from './components/AssetDialogCard';



interface Character {
  name: string;
  publicInfo: {
    age?: string;
    gender?: string;
    personality?: string;
  };
  characterMediaIds: string[];
  avatarsMap: {
    default?: string;
    [key: string]: string | undefined;
  };
  mediaPacks?: {
    id: string;
    coverUrl: string;
    title: string;
    mediaItems?: string[];
    type: string;
  }[];
}

interface Game {
  id: string;
  // TODO: Заменить any на конкретный тип
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

interface RightCardProps {
  analyticsData: {
    config_name?: string;
    scenario_name?: string;
    dialogId?: string;
  };
  game?: Game;
  isRestartGame?: boolean;
  characters: Character[];
  setIsSubscriptionModalOpen: () => void;
  setIsSignUpModalOpen: Dispatch<SetStateAction<boolean>>;
  setIsEmailConfirmationModalOpen: Dispatch<SetStateAction<boolean>>;
  isMobileView?: boolean;
  isPublic?: boolean;
  scenario: Record<string, unknown>;
}

const hasPublicInfo = (character: Character | null): boolean => {
  if (!character?.publicInfo) return false;

  return Object.values(character.publicInfo).some(
    value => value !== undefined && value !== null && value !== ''
  );
};

const hasGallery = (character: Character | null, currentUser: unknown): boolean => {
  if (!character) return false;

  const hasMediaIds = character.characterMediaIds.length > 0;
  const hasMediaPacks = character.mediaPacks && character.mediaPacks.length > 0;
  const allPacksArePaid = character.mediaPacks?.every(pack => pack.type === 'paid');

  if (hasMediaIds) return true;

  if (hasMediaPacks) {
    // @ts-ignore
    if (allPacksArePaid && !currentUser?.hasSubscription) return false;
    return true;
  }

  return false;
};

const CharacterAssetCardContainer: React.FC<RightCardProps> = (props) => {
  const {
    analyticsData,
    game,
    isRestartGame,
    characters,
    setIsSubscriptionModalOpen,
    setIsSignUpModalOpen,
    setIsEmailConfirmationModalOpen,
    isMobileView,
    isPublic,
    scenario
  } = props;

  const { currentUser } = useMappedState(state => ({
    currentUser: state.users.usersMap.get(state.users.currentUserId)
  }));

  const filteredCharacters = characters.filter(char => {
    return hasPublicInfo(char) || hasGallery(char, currentUser);
  });


  if (!game || isRestartGame) {
    return (
      <Root>
        <div>
          <Code
            backgroundColor="#696969"
            foregroundColor="#a9a9a9"
          />
          <Code
            backgroundColor="#696969"
            foregroundColor="#a9a9a9"
          />
          <Code
            backgroundColor="#696969"
            foregroundColor="#a9a9a9"
          />
          <Code
            backgroundColor="#696969"
            foregroundColor="#a9a9a9"
          />
        </div>
      </Root>
    );
  }

  return (
    <Root isMobileView={isMobileView}>
      <div>
        <AssetDialogCard
          {...game}
          gameId={game.id}
          charactersWithInfoCount={filteredCharacters.length}
          tags={game.tags}
          isPublic={isPublic}
          scenario={scenario}
          game={game}
          setIsSubscriptionModalOpen={setIsSubscriptionModalOpen}
          setIsSignUpModalOpen={setIsSignUpModalOpen}
          setIsEmailConfirmationModalOpen={setIsEmailConfirmationModalOpen}
        />
      </div>
      {!isMobile && (
        <div className={'mt-4'}>
          <CharacterAdditionalInfo
            analyticsData={analyticsData}
            characters={characters || []}
            setIsSubscriptionModalOpen={setIsSubscriptionModalOpen}
            setIsSignUpModalOpen={setIsSignUpModalOpen}
            setIsEmailConfirmationModalOpen={setIsEmailConfirmationModalOpen}
            game={game}
            scenario={scenario}
            currentUser={currentUser}
          />
        </div>
      )}
    </Root>
  );
};

export default CharacterAssetCardContainer;

const Root = styled.div<{ isMobileView?: boolean; children?: React.ReactNode }>`
  width: ${props => (props.isMobileView ? '100%' : '308px')};
  margin-left: ${props => (props.isMobileView ? '0px' : '20px')};
  overflow-y: scroll;
  scrollbar-width: thin;
  scrollbar-color: rgba(169, 169, 169, 0.3) transparent;

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(169, 169, 169, 0.3);
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: rgba(169, 169, 169, 0.5);
  }

  @media (max-width: 720px) {
    display: ${props => (props.isMobileView ? 'flex' : 'none')};
    flex-direction: column;
    ${props =>
    props.isMobileView &&
    `
      height: fit-content;
      overflow-y: scroll;
      padding-bottom: 100px;
    `}
  }
`;

